import * as UserActions from "./UserActions";
import * as ContactsActions from "./ContactsActions";
import * as ChannelActions from "./ChannelActions";
import * as DevelopersActions from "./DevelopersActions";
import * as ApplicationsActions from "./ApplicationsActions";
import * as PaymentsActions from "./PaymentsActions";
import * as InvoicesActions from "./InvoicesActions";
import * as ContactUtils from "../../Utils/ContactUtils";
import * as SandBoxAuthenticationActions from "./SandBoxAuthenticationActions";
import * as CustomEvents from "../../Constants/CustomEvents"

import LogService from "../../CommonSdk/LogService";

const LOG_TAG = "ACTIONS:COMMON";

export const onLoginActions = (user) => dispatch => {
    LogService.trace(LOG_TAG, "onLoginActions");
    dispatch(UserActions.getUserCustomData());
    dispatch(ChannelActions.getInformationChannel());

    const isDeveloper = ContactUtils.isDeveloper(user);
    const isSuperAdminOrAppSuperAdmin = ContactUtils.isSuperAdminOrAppSuperAdmin(user);
    const isSupportOrAppSupport = ContactUtils.isSupportOrAppSupport(user);

    if (isDeveloper || isSuperAdminOrAppSuperAdmin || isSupportOrAppSupport) {//not called when user or company admin
        dispatch(getDevelopersAndApplications())
            .catch(() => {
                document.dispatchEvent(new Event(CustomEvents.CUSTOM_EVENT_LOGIN_ACTIONS_ERROR));
            });
    } else {
        //cancel spinner
        dispatch(ApplicationsActions.clearApplicationsProgress());
    }

    if (isDeveloper) {
        dispatch(PaymentsActions.getPaymentMethods(user.id))
            .catch(() => {
                document.dispatchEvent(new Event(CustomEvents.CUSTOM_EVENT_LOGIN_ACTIONS_ERROR));
            });//to avoid chrome uncaught exceptions
        dispatch(InvoicesActions.getInvoiceAccount(user.id))
            .catch(() => {
                document.dispatchEvent(new Event(CustomEvents.CUSTOM_EVENT_LOGIN_ACTIONS_ERROR));
            });//to avoid chrome uncaught exceptions
        dispatch(SandBoxAuthenticationActions.getBaseServerEnvironment(user))
            .then(() => dispatch(SandBoxAuthenticationActions.authenticationCheckState()))
            .catch(() => { });//to avoid chrome uncaught exceptions
    }
}

export const onLogoutActions = () => dispatch => {
    LogService.trace(LOG_TAG, "onLogoutActions");
    dispatch(ChannelActions.clearChannel());
    dispatch(ContactsActions.clearContacts());
    dispatch(ApplicationsActions.clearApplications());
    dispatch(PaymentsActions.clearPaymentMethods());
    dispatch(InvoicesActions.clearInvoicesMethods());
    dispatch(SandBoxAuthenticationActions.logout())
        .then(() => dispatch(SandBoxAuthenticationActions.clearBaseServerEnvironment()))
        .catch(() => { });//to avoid chrome uncaught exceptions
}

export const getDevelopersAndApplications = () => dispatch => {
    return dispatch(DevelopersActions.getAllDevelopers())
        .then(developerList => dispatch(getApplicationsForDevelopers()))
        .catch(errorPayload => {
            if (errorPayload) //getAllDevelopers error
                return dispatch(getApplicationsForDevelopers())
                    .then(() => Promise.reject(errorPayload));
            return Promise.reject();
        });
};

const getApplicationsForDevelopers = () => (dispatch, getState) => {
    LogService.trace(LOG_TAG, "getApplications");

    let criteria = { format: "full" };
    const user = getState().contacts.user;
    const isSuperAdminOrAppSuperAdmin = ContactUtils.isSuperAdminOrAppSuperAdmin(user);
    const isSupportOrAppSupport = ContactUtils.isSupportOrAppSupport(user);

    const contactList = [...getState().contacts.contacts, getState().contacts.user];
    const developers = ContactUtils.getDevelopers(contactList);
    if (developers?.length > 0 && !isSuperAdminOrAppSuperAdmin && !isSupportOrAppSupport) {
        LogService.debug(LOG_TAG, "getApplications for developer");
        let ownerIdList = developers.map((developer) => developer.id);
        criteria = {
            ...criteria,
            ownerId: ownerIdList
        }
    }
    return dispatch(ApplicationsActions.getAllApplications(criteria));
}
